<template>
  <div class="full">
      <div v-if="!showedEntreprises && !sector" class="container-bubble">
        <bubble
          v-for="sector in usedSectors"
          :secteur="sector"
          :key="sector.id"
          :minEntreprise="minEntreprise"
          :maxEntreprise="maxEntreprise"
          @click.native="clickOnSector(sector)"
        />
      </div>
      <div v-if="!showedEntreprises && sector" >
        <div class="btn-retour">
          <span @click="goBack"><img src="https://i.ya-webdesign.com/images/right-arrow-white-png-2.png" alt="">
            Retour
          </span>
          <span>{{ sector.x_name }}</span>
        </div>
        <div class="container-bubble">
          <bubble
              v-for="domain in domainsForSecondStep"
              :secteur="domain"
              :key="domain.id"
              :minEntreprise="minEntreprise2"
              :maxEntreprise="maxEntreprise2"
              @click.native="clickOnDomain(domain)"
          />
        </div>
      </div>
      <div v-if="showedEntreprises">
        <div class="btn-retour">
          <span @click="goBack"><img src="https://i.ya-webdesign.com/images/right-arrow-white-png-2.png" alt=""> Retour</span>
          <span>{{ sector.x_name }} / {{ domain.x_name }}</span>
        </div>
        <entreprise v-for="currentEntreprise in currentEntreprises" :key="currentEntreprise.id" :entreprise="currentEntreprise"/>
      </div>
  </div>
</template>

<script>
import Bubble from './Bubble'
import Entreprise from './Entreprise'

export default {
  name: 'Sector',
  components : {
    Bubble,
    Entreprise
  },
  data: function () {
    return {
        minEntreprise: 100000,
        maxEntreprise: null,
        minEntreprise2: 100000,
        maxEntreprise2: null,
        currentEntreprises: [],
        showedEntreprises : null,
        sector: null,
        domain: null,
        domainsForSecondStep: [],
        usedSectors: []
    }
  },
  props: ['secteurs', 'entreprises', 'domains'],

  mounted() {

    if (this.secteurs && this.entreprises) {
      this.secteurs.forEach(secteur => secteur.entreprises = [])

      this.entreprises.forEach(entreprise => {
        const secteursForCompany = entreprise.x_cartoia_targetsectior

        if (secteursForCompany.length > 0) {
          this.secteurs
            .filter(s => secteursForCompany.includes(s.id))
            .map(s => s.entreprises.push(entreprise))
        }
      })

      this.usedSectors = this.secteurs.filter(s => s.entreprises && s.entreprises.length > 0)

      this.usedSectors.sort((a, b) => (a.x_name > b.x_name) ? 1 : -1)

      this.usedSectors.forEach(secteur => {
        const countEntreprises = secteur.entreprises.length
        if (countEntreprises >= this.maxEntreprise) {
          this.maxEntreprise = countEntreprises
        }
        if (countEntreprises <= this.minEntreprise) {
          this.minEntreprise = countEntreprises
        }
      })
    }
  },
  methods: {
    clickOnSector(secteur) {
      this.$emit('activeSplashScreen')
      this.domains.forEach(domain => domain.entreprises = [])
      this.domainsForSecondStep = this.domains
      this.sector = secteur

      secteur.entreprises.forEach(entreprise => {
        if (entreprise.x_cartoia_classification_1) {
          if (!this.domainsForSecondStep.find(d => d.id === entreprise.x_cartoia_classification_1[0])) {
            this.domainsForSecondStep.push({
              id: entreprise.x_cartoia_classification_1[0],
              x_name: entreprise.x_cartoia_classification_1[1],
              entreprises: [entreprise]
            })
          }
          else {
            this.domainsForSecondStep.find(d => d.id === entreprise.x_cartoia_classification_1[0]).entreprises.push(entreprise)
          }
        }
        if (entreprise.x_cartoia_classification_2) {
          if (!this.domainsForSecondStep.find(d => d.id === entreprise.x_cartoia_classification_2[0])) {
            this.domainsForSecondStep.push({
              id: entreprise.x_cartoia_classification_2[0],
              x_name: entreprise.x_cartoia_classification_2[1],
              entreprises: [entreprise]
            })
          }
          else {
            this.domainsForSecondStep.find(d => d.id === entreprise.x_cartoia_classification_2[0]).entreprises.push(entreprise)
          }
        }
      })

      this.domainsForSecondStep = this.domainsForSecondStep.filter(d => d.entreprises && d.entreprises.length > 0)

      this.domainsForSecondStep.sort((a, b) => (a.x_name > b.x_name) ? 1 : -1)

      const indexToMoveAtTheEnd = this.domainsForSecondStep.findIndex(d => d.id === 713)
      if (indexToMoveAtTheEnd) this.domainsForSecondStep.push(this.domainsForSecondStep.splice(indexToMoveAtTheEnd, 1)[0])

      this.domainsForSecondStep.forEach(domain => {
        const countEntreprises = domain.entreprises.length
        if (countEntreprises >= this.maxEntreprise2) {
          this.maxEntreprise2 = countEntreprises
        }
        if (countEntreprises <= this.minEntreprise2) {
          this.minEntreprise2 = countEntreprises
        }
      })

      if(this.domainsForSecondStep.length === 1) {
        this.clickOnDomain(this.domainsForSecondStep[0])
      }
    },
    clickOnDomain(domain) {
      this.$emit('activeSplashScreen')
      this.domain = domain
      this.currentEntreprises = domain.entreprises
      this.showedEntreprises = true
    },
    goBack() {
      this.$emit('activeSplashScreen')
      if (this.showedEntreprises) {
        this.currentEntreprises = []
        this.showedEntreprises = false
        this.domain = false
        if(this.domainsForSecondStep.length === 1) {
          this.sector = false
          this.domainsForSecondStep = []
        }
      }
      else {
        this.sector = false
        this.domainsForSecondStep = []
      }
    }
  }
}
</script>
